import { Box, Collapse, Flex, HStack, Image, Divider } from "@chakra-ui/react";
import { Icon } from "@equidefi/ui/icon";
import { NavLink } from "react-router";
import EquidefiLogo from "../../images/logo-white.png";
import { IssuerInfo, NavMenu, UserGreeting, WorkflowProgress, PoweredBySection } from "./components";
import { useAuth } from "@equidefi/portals/hooks/useAuth";
import { Text } from "@equidefi/ui";

export const NavMobileView = ({ position, offering, logout, menu }) => {
  const MenuIcon = menu.isOpen ? Icon.X : Icon.Menu;
  const { isLoggedIn } = useAuth();
  const isSimpleHeader = position === 1 && !isLoggedIn;

  // Shared components
  const LogoImage = () => (
    <Image
      src={offering?.issuer?.wide_logo_url || EquidefiLogo}
      alt={offering?.issuer?.name || "EquiDeFi"}
      maxH="42px"
      maxW="138px"
      objectFit="contain"
    />
  );

  const HelpIcon = () => (
    <Box w="1.5em">
      <NavLink to="/support">
        <Icon.HelpCircle size="24px" />
      </NavLink>
    </Box>
  );

  const LeftSection = () => (
    <Box w="1.5em">{!isSimpleHeader && <MenuIcon size="1.5em" cursor="pointer" onClick={menu.onToggle} />}</Box>
  );

  return (
    <Flex
      position="sticky"
      direction="column"
      w="full"
      zIndex="2"
      color="white"
      borderBottomRadius="21px"
      p="15px"
      bgColor={offering?.issuer?.brand_color || "primary"}
      minH="74px"
      align="center"
      justify="center">
      {/* Header Section */}
      <HStack
        minW="full"
        gap={{ base: "0", lg: "30px" }}
        alignItems="center"
        justifyContent="space-between"
        minH="44px"
        px="15px">
        <LeftSection />
        <LogoImage />
        <HelpIcon />
      </HStack>

      {/* Collapsible Menu Section */}
      {!isSimpleHeader && (
        <Box as={Collapse} minW="full" in={menu.isOpen}>
          <UserGreeting />
          <IssuerInfo offering={offering} isLoggedIn />
          {offering && position && (
            <Box mt={4} mb={8}>
              <WorkflowProgress offering={offering} position={position} />
            </Box>
          )}
          <NavMenu logout={logout} menu={menu} offering={offering} />

          <Divider maxH={0} mt={4} />
          <PoweredBySection />
        </Box>
      )}
    </Flex>
  );
};
